@if (state(); as currentState) {
  <tiime-overlay>
    <div tiimeOverlayContent>
      <div class="global-search-wrapper">
        <div class="global-search-icon">
          <mat-icon
            fontSet="fontastic"
            fontIcon="icon-ic-search"
            (click)="focusSearchInput()"
            data-cy="search-input-icon"
          ></mat-icon>
        </div>
        <input
          #searchInput
          class="global-search-input"
          placeholder="Rechercher..."
          [formControl]="searchControl"
          data-cy="global-search-input"
        />
      </div>
      <tiime-tabs>
        <tiime-tab>
          <tiime-tab-title>
            <ng-container
              [ngTemplateOutlet]="tabTitle"
              [ngTemplateOutletContext]="{
                label: 'Dossiers',
                count: currentState.companies?.length,
                loading: currentState.companiesLoading
              }"
            ></ng-container>
          </tiime-tab-title>
          <ng-container
            [ngTemplateOutlet]="tabNoResults"
            [ngTemplateOutletContext]="{
              count: currentState.companies?.length,
              loading: currentState.companiesLoading
            }"
          ></ng-container>
          <cdk-virtual-scroll-viewport
            appVirtualScrollViewportSize
            class="tiime-virtual-scroll-viewport"
            [itemSize]="virtualScrollItemSize"
            [minBufferPx]="virtualScrollBufferPx"
            [maxBufferPx]="virtualScrollBufferPx"
          >
            <mat-option
              (onSelectionChange)="selectCompany($event, company)"
              *cdkVirtualFor="let company of currentState.companies; trackBy: trackById"
            >
              <app-company-option [company]="company"></app-company-option>
            </mat-option>
          </cdk-virtual-scroll-viewport>
        </tiime-tab>
        @if (canAccessToContracts$ | async) {
          <tiime-tab>
            <tiime-tab-title>
              <ng-container
                [ngTemplateOutlet]="tabTitle"
                [ngTemplateOutletContext]="{
                  label: 'Contrats',
                  count: currentState.contracts?.length,
                  loading: currentState.contractsLoading
                }"
              ></ng-container>
            </tiime-tab-title>
            <ng-container
              [ngTemplateOutlet]="tabNoResults"
              [ngTemplateOutletContext]="{
                count: currentState.contracts?.length,
                loading: currentState.contractsLoading
              }"
            ></ng-container>
            <cdk-virtual-scroll-viewport
              appVirtualScrollViewportSize
              class="tiime-virtual-scroll-viewport"
              [itemSize]="virtualScrollItemSize"
              [minBufferPx]="virtualScrollBufferPx"
              [maxBufferPx]="virtualScrollBufferPx"
            >
              <mat-option
                (onSelectionChange)="selectContract($event, contract.id)"
                *cdkVirtualFor="let contract of currentState.contracts; trackBy: trackById"
              >
                <app-contract-option [contract]="contract"></app-contract-option>
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </tiime-tab>
          <tiime-tab>
            <tiime-tab-title>
              <ng-container
                [ngTemplateOutlet]="tabTitle"
                [ngTemplateOutletContext]="{
                  label: 'Prospects',
                  count: currentState.prospects?.length,
                  loading: currentState.prospectsLoading
                }"
              ></ng-container>
            </tiime-tab-title>
            <ng-container
              [ngTemplateOutlet]="tabNoResults"
              [ngTemplateOutletContext]="{
                count: currentState.prospects?.length,
                loading: currentState.prospectsLoading
              }"
            ></ng-container>
            <cdk-virtual-scroll-viewport
              appVirtualScrollViewportSize
              class="tiime-virtual-scroll-viewport"
              [itemSize]="virtualScrollItemSize"
              [minBufferPx]="virtualScrollBufferPx"
              [maxBufferPx]="virtualScrollBufferPx"
            >
              <mat-option
                (onSelectionChange)="selectProspect($event, prospect.id)"
                *cdkVirtualFor="let prospect of currentState.prospects; trackBy: trackById"
              >
                <app-prospect-option [prospect]="prospect"></app-prospect-option>
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </tiime-tab>
        }
      </tiime-tabs>
    </div>
  </tiime-overlay>
}

<ng-template #tabTitle let-label="label" let-count="count" let-loading="loading">
  <div class="tab-title" (click)="selectTab()">
    {{ label }}
    @if (searchControl.value?.length >= SEARCH_MIN_LENGTH) {
      <div class="tiime-tab-label-infos">
        @if (loading) {
          <mat-progress-spinner diameter="12" color="primary" mode="indeterminate"></mat-progress-spinner>
        } @else {
          <span class="tiime-tab-label-badge">{{ count }}</span>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #tabNoResults let-count="count" let-loading="loading">
  @if (count === 0) {
    <div class="no-results-container">
      @if (searchControl.value?.length >= SEARCH_MIN_LENGTH) {
        Aucun résultat
      } @else {
        Rechercher...
      }
    </div>
  }
</ng-template>
